import { rgbOrRgbaToHSLA } from './rgbOrRgbaToHSLA';
import { hexOrHexAToRgba } from './hexOrHexAToRgba';
export var hexOrHexAToHSLA = function (color) {
    return rgbOrRgbaToHSLA(hexOrHexAToRgba(color));
};
